import { z } from 'zod';
import {
  FlowApprovalTypeSchema,
  FlowApprovalDecisionOptionSchema,
  FlowApprovalAssigneeSchema,
} from './nodes.js';
import { FlowApprovalAnswerSchema, FlowApprovalResponseSchema } from './run.js';

/**
 * The assignee-facing gate payload: the author-templated prompt, the gate's
 * config, and the single predecessor output (`context`). Wider run data
 * (other node outputs, flow state, trigger data) is deliberately not part
 * of the request — authors template what reviewers need into the prompt.
 */
export const FlowApprovalRequestSchema = z.object({
  runId: z.string(),
  runName: z.string(),
  nodeId: z.string(),
  nodeName: z.string(),
  approvalType: FlowApprovalTypeSchema,
  prompt: z.string(),
  context: z.record(z.string(), z.unknown()).nullable().optional(),
  allowFeedback: z.boolean(),
  decisionOptions: z.array(FlowApprovalDecisionOptionSchema).optional(),
  /** Effective targets this approval is reported to and gated on. */
  assignees: z.array(FlowApprovalAssigneeSchema).optional(),
  iteration: z.number().int(),
  createdAt: z.number(),
});
export type FlowApprovalRequest = z.infer<typeof FlowApprovalRequestSchema>;

export { FlowApprovalAnswerSchema, FlowApprovalResponseSchema };
export type { FlowApprovalAnswer, FlowApprovalResponse } from './run.js';
